var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-gap-8"},[_c('a',{attrs:{"href":_vm.value.secure_url}},[_vm._v(_vm._s(_vm.value.secure_url.substring(0, 20))+"...")]),_c('copy-button-action',{attrs:{"value":_vm.value.secure_url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }